import React from 'react';
import cx from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import ReactMenu from '@material-ui/core/Menu';
import ReactMenuItem from '@material-ui/core/MenuItem';
import Box from '../layout/box';
import { makeStyles } from '../../theme';
import { callWith } from '../../../util';

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const menuStyles = makeStyles(
    ({ palette, spacing }) => ({
        menuBtn: {
            padding: spacing(1),
            color: palette.primary.main,

            // Active/Clicked State of the button
            '&:hover': {
                color: palette.primary.contrastText,
                backgroundColor: palette.primary.main
            }
        }
    })
);

 const Menu = React.memo(({ id, icon: Icon, items, onSelect, menuProps: { menuBtnCls, ...otherMenuProps } = {} }) => {
    const classes = menuStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const numOfItems = items.length;

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

	const handleMenuClose = () => {
		setAnchorEl(null);
    };
	
	const handleClickedItem = (item) => {
		setAnchorEl(null);
		if(onSelect)onSelect(item)
    };

    return (
        <Box>
            <IconButton
                aria-controls={id}
                aria-haspopup="true"
                variant="contained"
                onClick={handleMenuOpen}
                className={cx(classes.menuBtn, menuBtnCls)}
                disabled={numOfItems === 0}
                >
                <Icon />
            </IconButton>
            {numOfItems > 0 && (
                <ReactMenu {...otherMenuProps} id={id} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
                        {items.map((item, i) => (
                            <ReactMenuItem key={`${id}-item-${i}`} onClick={callWith(handleClickedItem, item)}>
                                {item}
                            </ReactMenuItem>
                        ))}
                </ReactMenu>
            )}
        </Box>
    )
});

export default Menu;